module.exports = __webpack_public_path__ + "img/yuuU.cd0e56e.svg";